import { Link } from 'components/Link';
import { CandidateType } from 'components/Slate/Candidates/Candidates';
import { UtilityText } from 'components/Typography';
import { getCustomCheckoutLink } from 'helpers/donate';
import { useAppSelector } from 'helpers/hooks';
import { getUrlParams } from 'helpers/utils';
import { useRedirectAfterLogin } from 'hooks/useRedirectAfterLogin';
import { FC } from 'react';
import { getDonatePageData } from 'selectors/donatePage';
import { getEventData } from 'selectors/eventPage';
import { setRefValue } from 'services/storage';

interface Props {
  candidates: CandidateType[];
  isCheckout?: boolean;
  isRecurring?: boolean;
}

export const LoginCTA: FC<Props> = ({ candidates, isCheckout = false, isRecurring = false }) => {
  const { handleUpdateCredentials } = useRedirectAfterLogin();
  const { urlEvent, urlRef } = getUrlParams();
  const { page, event } = useAppSelector(state => ({
    page: getDonatePageData(state),
    event: getEventData(state),
  }));

  const loginClick = () => {
    if (urlRef) setRefValue(urlRef);
    const pageData = urlEvent ? event : page;
    const url = new URL(window.location.href);
    let postLoginUrl = '';

    if (!isCheckout || !pageData) {
      const pathname = url.pathname === '/' ? '/profile' : url.pathname;
      postLoginUrl = `${pathname}${url.search}`;
    } else if (pageData) {
      const checkoutUrl = new URL(getCustomCheckoutLink(pageData, candidates, isRecurring));
      postLoginUrl = `${url.pathname}${checkoutUrl.search}`;
    }
    handleUpdateCredentials(postLoginUrl);
  };

  return (
    <UtilityText>
      Have an Oath account?{' '}
      <Link $fontSize="inherit" onClick={loginClick}>
        Sign in to give faster.
      </Link>
    </UtilityText>
  );
};
